import { render, staticRenderFns } from "./ListCreate.vue?vue&type=template&id=4bde9d5a&"
import script from "./ListCreate.vue?vue&type=script&lang=js&"
export * from "./ListCreate.vue?vue&type=script&lang=js&"
import style0 from "./ListCreate.vue?vue&type=style&index=0&id=4bde9d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports